module.exports = {
    loading: {
        en: "Loading",
        fi: "Ladataan"
    }
};